import { defineMessages } from '@atlassian/jira-intl';

const messages = defineMessages({
	boardHeader: {
		id: 'software-size-limit-error-empty-state.board-header',
		defaultMessage: 'Too many issues to display the board',
		description:
			'Message shown when a next-gen board/backlog would fail to load due to having 5000+ issues',
	},
	backlogHeader: {
		id: 'software-size-limit-error-empty-state.backlog-header',
		defaultMessage: 'Too many issues to display the backlog',
		description:
			'Message shown when a next-gen board/backlog would fail to load due to having 5000+ issues',
	},
	timelineHeader: {
		id: 'software-size-limit-error-empty-state.timeline-header',
		defaultMessage: 'Too many issues to display the timeline',
		description:
			'Message shown when a next-gen board/backlog would fail to load due to having 5000+ issues',
	},
	boardDescription: {
		id: 'software-size-limit-error-empty-state.board-description',
		defaultMessage:
			'The board can only display up to 5,000 issues at a time. Move or delete issues to continue using your board.',
		description: 'Description of the 5000+ issues board size limit error.',
	},
	backlogDescription: {
		id: 'software-size-limit-error-empty-state.backlog-description',
		defaultMessage:
			'The backlog can only display up to 5,000 issues at a time. Move or delete issues to continue using your backlog.',
		description: 'Description of the 5000+ issues backlog size limit error.',
	},
	timelineDescription: {
		id: 'software-size-limit-error-empty-state.timeline-description',
		defaultMessage:
			'The timeline can only display up to 5,000 issues at a time. Move or delete issues to continue using your timeline.',
		description: 'Description of the 5000+ issues timeline size limit error.',
	},
	editFilter: {
		id: 'software-size-limit-error-empty-state.edit-filter',
		defaultMessage: 'Edit filter',
		description: 'Go to general board settings page for CMP boards/backlogs',
	},
	moreLinkText: {
		id: 'software-size-limit-error-empty-state.more-link-text',
		defaultMessage: 'More about issue limits',
		description: 'Link to the page about issue limits for boards/backlog/timeline',
	},
});

export default messages;
